module.exports = __webpack_public_path__ + "img/cases-brand-herborist-10.0f9fa618.jpg";